import { useContext, useEffect } from 'react'

import { deprecationContext } from './deprecationContext'

/**
 * Hook for handling a property that may be deprecated
 */
export const useDeprecation = (isDeprecated: boolean) => {
	const context = useContext(deprecationContext)

	if (!context) throw new Error('Cannot useDeprecation without a deprecation context')

	useEffect(() => {
		if (!isDeprecated) return

		context.registerDeprecated()
	}, [context, isDeprecated])

	return { shouldShow: !isDeprecated || context.showDeprecated }
}
